
    import './styles.scoped.css';
    export default {
  "resize-active": "_resize-active_1d4ww_3",
  "resizer": "_resizer_1d4ww_8",
  "resizer-active": "_resizer-active_1d4ww_24",
  "tracker": "_tracker_1d4ww_34"
};
  